import React from 'react'
import styles from './AsAt.module.css'

// "As at HH:MM" (h 4167-4177): a historical or filtered view says when its
// data is from, so nobody has to guess whether it is stale. The view refetches
// on its own (useRefetch: window focus, reconnect; its own load on a filter or
// date change) and the stamp moves with each fetch that lands.
export function asAtText(at: Date) {
  const hh = String(at.getHours()).padStart(2, '0')
  const mm = String(at.getMinutes()).padStart(2, '0')
  return `As at ${hh}:${mm}`
}

// A view of today with the live stream up (lib/live.ts) is pushed, not stamped:
// it says so instead, and the stamp comes back if the stream goes down. Not
// "Live": that is a day's state (LIVE, CLOSED, LOCKED), and Timesheets shows
// both side by side.
export const LIVE_TEXT = 'Receiving updates'
export function AsAt({ at, className, live = false }: { at: Date | null; className?: string; live?: boolean }) {
  if (!at) return null
  if (live) {
    return (
      <span className={className || styles.asAt} data-testid="live-now" title={`Changes arrive as they are recorded. Last fetched ${at.toLocaleString()}.`}>
        <span className={styles.liveDot} aria-hidden="true" />
        {LIVE_TEXT}
      </span>
    )
  }
  return (
    <span className={className || styles.asAt} data-testid="as-at" title={`Fetched ${at.toLocaleString()}. It fetches again when you come back to this window, change the period or reconnect.`}>
      {asAtText(at)}
    </span>
  )
}
